import React, { Component } from 'react';
import { translate } from 'react-i18next';
import {connect} from 'react-redux';
import _ from 'underscore';

import DatabaseService from 'services/DatabaseService.js';
import Utils from 'utils/Utils.js';
import AuthUtils from 'utils/AuthUtils.js';
import ChangePasswordModal from './ChangePasswordModal.js';


class ChangePasswordModalContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {valid:false,
					  password:'', 
					  passwordConfirm:'', 
                      oldPassword:'',
                      passwordError:'', 
                      passwordConfirmError:'', 
                      oldPasswordError:'',
                      termsError:'', 
                      error:''};    
		this.onPasswordChange = this.onPasswordChange.bind(this);
		this.onPasswordConfirmChange = this.onPasswordConfirmChange.bind(this);
		this.onOldPasswordChange = this.onOldPasswordChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
        this.onBlur = this.onBlur.bind(this);
		this.isValid = this.isValid.bind(this);
        this.isValidDebounced = _.debounce(this.isValid, 1000);
    }

	onPasswordChange(event) {
		this.setState({password: event.target.value}, this.isValidDebounced);
	}

	onPasswordConfirmChange(event) {
		this.setState({passwordConfirm: event.target.value}, this.isValidDebounced);
	}

	onOldPasswordChange(event) {
		this.setState({oldPassword: event.target.value}, this.isValidDebounced);
	}

	onSubmit(event) {
        if(this.isValid(true)) {
            this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:true});
            DatabaseService.changePassword(this.state.password, this.state.oldPassword)
                .then(()=>{
                    this.props.onClose();
                })
                .catch((error) => {
                    this.setState({error:String(error),password:'', passwordConfirm:''});
                    console.error(error);
                    //window.alert('error: ' + error);
                })
                .then(()=>{ //Always
                    this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:false});
                });
        }
    }

    onBlur(event) {
        console.log('onBlur');
        this.isValid();
    }

	isValid(submit, blur) {
		var valid = true;

		this.setState({passwordError:'', passwordConfirmError:'', oldPasswordError:''});

		if((this.state.password).length === 0){
            if(submit) {
			    this.setState({passwordError:this.props.t('Please choose your password')});
            }
            valid = false;
		}

		if(0 < this.state.password.length && this.state.password.length < AuthUtils.minPasswordLength){
			this.setState({passwordError:this.props.t('Password must be at least {{length}} characters', {length: AuthUtils.minPasswordLength})});
            valid = false;
		}

		if((this.state.passwordConfirm).length === 0){
            if(submit) {
			    this.setState({passwordConfirmError:this.props.t('Please confirm your password')});
            }
            valid = false;
		}

		if((this.state.password.length>0 && this.state.passwordConfirm.length>0) && this.state.password!=this.state.passwordConfirm){
			this.setState({passwordConfirmError:this.props.t('This field should be identical to the password field')});
            valid = false;
		}

		if((this.state.oldPassword).length === 0){
            if(submit) {
			    this.setState({oldPasswordError:this.props.t('Please enter your password')});
            }
            valid = false;
		}

        this.setState({valid:valid});

		return valid;	
	}

    render() {
        return <ChangePasswordModal
                    valid={this.state.valid}
                    password={this.state.password}
                    passwordConfirm={this.state.passwordConfirm}
                    oldPassword={this.state.oldPassword}
                    passwordError={this.state.passwordError}
                    passwordConfirmError={this.state.passwordConfirmError}
                    oldPasswordError={this.state.oldPasswordError}
                    error={this.state.error}
                    onPasswordChange={this.onPasswordChange}
                    onPasswordConfirmChange={this.onPasswordConfirmChange}
                    onOldPasswordChange={this.onOldPasswordChange}
                    onBlur={this.onBlur}
                    onSubmit={this.onSubmit}
                    onClose={this.props.onClose} />;
    }
}

export default connect()(translate('authentication')(ChangePasswordModalContainer));



// WEBPACK FOOTER //
// ./src/modules/settings/ChangePasswordModalContainer.js